import YFooter from './YFooter.vue';
export default YFooter